import { isDefined } from '../../../helpers/utils';
import {
  countInstructionHubBlockedAssignments,
  isFullyInstructionHubBlocked
} from '../../../helpers/instruction-hub/instruction-hub-assignments';

export default function getTopicCellSummary(
  studentCells,
  activities,
  blockedLookup
) {
  const topicCells = studentCells.filter((cell) =>
    activities.some(
      (activity) =>
        cell.activityId === activity.activityId &&
        cell.taskType === activity.taskType
    )
  );
  const scores = topicCells
    .map((cell) => cell.result?.score)
    .filter((score) => isDefined(score));

  return {
    hasAssignments: topicCells.some((cell) => isDefined(cell.assignment)),
    hasResults: scores.length > 0,
    resultAverage:
      scores.length > 0
        ? scores.reduce((sum, score) => sum + score, 0) / scores.length
        : 0,
    selectedCells: topicCells.filter((cell) => cell.isSelected).length,
    isTopicInstructionHubBlocked: isFullyInstructionHubBlocked(
      countInstructionHubBlockedAssignments(topicCells, blockedLookup),
      topicCells.length
    )
  };
}



// WEBPACK FOOTER //
// ./components/grid/collapsed/get-topic-cell-summary.js